import React, {useContext} from 'react';
import UserSessionContext from 'context/UserSessionContext';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import TitanLogoImage from 'assets/images/authentication/titan-logo.png';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none'
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  },
  logoImage: {
    display: 'flex',
    maxWidth: '140px'
    // height: theme.spacing(4)
  }
}));

const Topbar = ({ onSidebarOpen, className, ...rest }) => {
  const classes = useStyles();
  const { session } = useContext(UserSessionContext);
  const { homepagePreference } = session;
  return (
    <AppBar {...rest} className={classes.root}>
      <Toolbar>
        <Link to={homepagePreference}>
          <img alt="Logo" src={TitanLogoImage} className={classes.logoImage} />
        </Link>
        <div className={classes.flexGrow} />
        <Hidden lgUp>
          <IconButton aria-label="menu" color="inherit" onClick={onSidebarOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func.isRequired
};

Topbar.defaultProps = {
  className: null
};

export default Topbar;
